import React, { useEffect, useState, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import "./design.css";

import DesignActivity from "../../components/designActivity";
import SidebarExtension from "../../components/Sidebar/SidebarExtension";
import SidebarPanel from "../../components/Sidebar/SidebarPanel";

import ActivityCategories from "../../components/ActivityCategories";
import { closeCategoryDropdown, closeVideoModalActive, updateCategories } from "../../redux/slices/activityCategories";
import { updateCoverPhoto, updateDescription, updateDuonutThumbnailSet, updateDuonutToEdit, updateSettings, updateTitle } from "../../redux/slices/duonutSettings";
import { setDefaultSelectedActivity, setUserActivity, toggleIsVideo, toggleVideoVisible, updateDiscardSaveModal, updateIsEditing, updateSuccessModal } from "../../redux/slices/userActivity";
import { createDuonut, fetchActivityCategories, fetchActivityTypes } from "../../services/activity";
import { getDuonut } from "../../services/duonut";
import { isUserActivityUpdated } from "../../utils";
import SuccessModal from "../../components/Modals/SuccessModal/SuccessModal";
import { updateActivityTypes } from "../../redux/slices/activityTypes";

export default function Design({ editing }) {
  const [slidesActive, setSlidesActive] = useState(false);
  const { categories, selectedCategoryName } = useSelector((state) => state.activityCategories);
  const { isLoggedIn } = useSelector((state) => state.user);
  const { id: duonutId } = useParams();
  const location = useLocation();
  const { userActivities, selectedUserActivity, discardSaveModalActive, isVideo, successModal, isEditing } = useSelector((state) => state.userActivity);
  const activity = userActivities[selectedUserActivity];
  const [loading, setLoading] = useState(false);
  const [isCreated, setIsCreated] = useState(false);
  const { title, video, video_url } = useSelector((state) => state.duonutSettings.settings);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(closeCategoryDropdown());
    dispatch(closeVideoModalActive());
  }, []);

  const onBack = () => {
    navigate('/')
    console.log('back');
  }
  useEffect(() => {
    window.addEventListener('popstate', onBack, false);
    window.history.pushState(null, null, window.location.pathname);
    return () => {
      window.removeEventListener('popstate', onBack)
    }
  }, [])

  useEffect(() => {
    return () => {
      if (successModal.isEdited === true) {
        dispatch(updateSuccessModal({ isEdited: false }));
      }
    };
  }, [location.pathname]);

  function handleUnLoad(event) {
    if (!discardSaveModalActive) {
      event.returnValue = null;
      dispatch(updateDiscardSaveModal());
    }
  }

  let interval = null;
  let dep = {}
  if (userActivities[0] !== undefined) {
    dep = Object.keys(userActivities[0]).length
  }

  useEffect(() => {
    const controller = new AbortController();
    interval = setInterval(() => {
      if (isLoggedIn && loading === false && editing === false) {
        clearInterval(interval);
        if (userActivities.length < 1) return;
        if (userActivities[0] === undefined) return;
        if (Object.keys(userActivities[0]).length < 3) return;
        if (location.pathname.substring(0, 7) === "/design" && location.pathname.length >= 8) return;
        // console.log("duonut creation ue");
        // setLoading(true);
        createDuonut({ duonut_category: 1, name: "Untitled", video_url, video }, controller, (err, res) => {
          // setLoading(false);
          clearInterval(interval);
          if (err) {
            // console.log(err.response);
            // setPublishing(false);
            return;
          }
          console.log('DUONUT CREATED --- ');
          navigate(`/design/${res?.data?.id}`);
          // console.log(res.data);
        });
      }
    }, 10);

    return () => {
      controller.abort();
      clearInterval(interval)
    };
  }, [isLoggedIn, isVideo, loading, dep, editing, video, video_url]);

  useEffect(() => {
    if (!isLoggedIn && isUserActivityUpdated(userActivities)) {
      window.addEventListener("beforeunload", handleUnLoad);
    }
    return () => {
      window.removeEventListener("beforeunload", handleUnLoad);
    };
  }, [activity, discardSaveModalActive, isLoggedIn]);

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const typeId = searchParams.get("selectedActivityId");
    dispatch(setDefaultSelectedActivity({ defaultSelectedActivity: { id: parseInt(typeId), isSet: false } }));
    // navigate("/design");
  }, []);

  useEffect(() => {
    if (editing === true) {
      fetchDuonut();
    }
  }, [duonutId]);

  const fetchDuonut = () => {
    getDuonut(duonutId, (err, res) => {
      console.log("fetch duonut resp", res);
      if (err) {
        console.log(err);
        navigate("/design");
        dispatch(setUserActivity({ activities: [{}], defaultActivities: [{}] }));
        return;
      }
      console.log('response', res.data);
      // return
      // if(!localStorage.getItem('userId')) return navigate('/')
      // console.log(res.data.created_by)
      // console.log(localStorage.getItem('userId'))
      if (parseInt(localStorage.getItem("userId")) !== parseInt(res.data.created_by)) {
        navigate("/");
        return;
      }

      let mastersData = [];
      // console.log(mastersData)
      for (const [key, value] of Object.entries(res.data.masters_data)) {
        if (value.length >= 1) {
          mastersData.push(...value);
        }
      }
      mastersData = mastersData.sort((a, b) => (a.priority > b.priority ? 1 : -1));
      console.log("initial data", res.data);

      if (res.data.video !== null || res.data.video_url !== null) {
        dispatch(toggleIsVideo({ isVideo: true }))
        dispatch(toggleVideoVisible({ videoVisible: true }))
        mastersData = mastersData.map((master, idx) => {
          const timestamp = res.data.timestamps[idx]
          if(timestamp){
            return {
              ...master,
              question_id:{
                ...master.question_id,
                timestamp: timestamp.timestamp
              }
            }
          }else{
            return master
          }
        })
      }
      // console.log("mastersData", mastersData);
      let settings = {
        title: res.data.name,
        description: res.data.description,
        isPublic: res.data.visibility,
        isPrivate: !res.data.visibility,
        category: res.data.duonut_category_id.id,
        // video: res.data.video,
        ...(res.data.video && {video: res.data.video}),
        ...(res.data.video_url && {video_url: res.data.video_url}),
        // video_url: res.data.video ? res.data.video : res.data.video_url,
      };
      let cover_photo;

      if (res.data.thumbnail) cover_photo = { name: "thumbnail.png", uri: res.data.thumbnail };
      else cover_photo = {};

      localStorage.removeItem("userActivities");
      dispatch(updateSettings({ settings }));
      dispatch(updateCoverPhoto({ coverPhoto: cover_photo }));
      dispatch(updateDuonutToEdit({ duonutToEdit: res.data }));
      dispatch(updateIsEditing({ isEditing: true }));
      dispatch(updateDuonutThumbnailSet({ thumbnails: res.data.duonutthumbnail_set }));
      mastersData.length >= 1 && dispatch(setUserActivity({ activities: mastersData, defaultActivities: mastersData }));
      // navigate('/design')
    });
  };

  const handleNavigate = () => {
    navigate("/myduonuts");
    dispatch(updateSuccessModal({ active: false }));
  };

  const resetUserActivities = () => {
    dispatch(updateSuccessModal({ active: false }));
    localStorage.removeItem("userActivities");
    localStorage.removeItem("duonutSettings");
    navigate('/design')
    // if (!successModal.isEdited) {
    dispatch(setUserActivity({ activities: [{}], defaultActivities: [{}] }));
    dispatch(updateTitle(""));
    dispatch(updateDescription(""));
    // }
  };

  const handleClose = () => {
    dispatch(updateSuccessModal({ active: false }));
  };

  return (
    <div className="design-page">
      <div className="sidebar_container">
        <SidebarPanel duonutId={duonutId} />
        <SidebarExtension duonutId={duonutId} />
      </div>
      <DesignActivity setSlidesActive={setSlidesActive} slidesActive={slidesActive} />

      {/* only for mobile */}
      <div className="design-page__bottom">
        <ActivityCategories />
      </div>

      <div className="activity_slides_icon">
        <img src="/assets/icons/slides.svg" onClick={() => setSlidesActive(true)} />
      </div>

      {successModal.active && (
        <SuccessModal
          message={successModal.message}
          description="Go to My Duonuts to access your published or saved Duonuts."
          secondaryButton={{
            text: "My Duonuts",
            onClick: handleNavigate,
          }}
          primaryButton={{
            text: "Create New",
            onClick: resetUserActivities,
          }}
          handleClose={handleClose}
        />
      )}

      {/* <div>
        <button onClick={onClick}>Send</button>
      </div> */}
    </div>
  );
}
